<template>
  <div class="navbar" :class="{'personalUi':datas.isPersonal}" >
    <bottomNav v-if="datas.allBottom"></bottomNav>
    <div class="navbar-list" :style="bottomBgPic"  v-else>
      <div class="navbar-item" :class="datas.layout" v-for="(item, index) in datas.items" :key="index" @click="handle(item)">
        <img :src="item.url" v-if="!item.isHide" alt />
        <p :style="style">{{item.name}}</p>
      </div>

      <div class="personal" v-if="datas.isPersonal">
        <img :src="datas.personalPic" @click="goPersonal">
      </div>

    </div>
    <div class="bg" v-if="datas.isPersonal"></div>
    <serviceQcode ref="serviceQcode"></serviceQcode>
     <IPhoneBottomHeight class="iPhoneBottom"></IPhoneBottomHeight>
  </div>
</template>

<script>
// 菜单项
import { jAlert3, jAlert5 } from "@/base/jAlert/jAlert";
import { getStorage } from '@/utils/wxuser';
import serviceQcode from "@/components/serviceQcode";
import bottomNav from "@/components/bottomNav";
export default {
  props: ["datas"],
  data() {
    return {
      tel: "",

    };
  },
  components: {
    serviceQcode,
    bottomNav
  },
  computed: {
    style() {
      return `color:${this.datas.color};`
    },

    bottomBgPic(){
				var style = ''
				if(this.datas.isBottom&&this.datas.bgPic){
					style +=`background: url(${this.datas.bgPic}) no-repeat;background-size: cover;`
				}else{
          style +=`background:#fff;box-shadow: 0 0.053333rem 0.213333rem rgba(63, 43, 43, 0.4);`
        }
				return style
			},
  },
  methods: {
    goPersonal() {
      window.location.href = this.datas.personalLink
    },
    handle(item) {
      if (item.name === "客服") {
        if (getStorage('isQrCode')) {
          this.$refs.serviceQcode.isServiceQcode =true
        } else if(item.link) {
          window.location.href = "tel:" + item.link
        }
        return;
      } else {
        if (item.link != "") {
          if (item.link.indexOf('http') != -1) {
            item.link = item.link.replace('/?/=', '/?/')
            var links = item.link.split('?')
            if (links.length > 0) {
              if (links[links.length - 1].indexOf('=') != -1) {
                item.link = item.link + '&backPage=' + encodeURIComponent(window.location.href);
              } else {
                item.link = item.link + '?backPage=' + encodeURIComponent(window.location.href);
              }
              this.goLink(item.link)
            } else {
              this.goLink(item.link)
             
            }
          } else {
            jAlert3(item.link)
            return;
          }


        }
      }
    },

  },
  mounted() {
    if(this.datas.allBottom){
      this.datas.isPersonal =false
    }

    if (this.datas.isPersonal) {
      if (this.datas.layout == 'twofor') {
        this.datas.layout = 'threefor'
        this.datas.items.splice(1, 0, { 'isHide': true });
      }
      if (this.datas.layout == 'fourfor') {
        this.datas.layout = 'fivefor'
        this.datas.items.splice(2, 0, { 'isHide': true });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.navbar {
  position: fixed;
  bottom: 0;
  left: 0;
  
  width: 100%;
  z-index: 10;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  .navbar-list {


    width: 100vw;
    background: #fff;
    padding: 0 0.266667rem;
    box-sizing: border-box;

  }
  .bg {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: -1;
    top: -0.453333rem;
    height: 1.173333rem;
    width: 1.173333rem;
    padding: 0.266667rem;
    border-radius: 50%;
    box-shadow: 0 0.053333rem 0.213333rem rgba(0, 0, 0, 0.4);
  }
  .iPhoneBottom{
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 100%;

  }
  .navbar-item {
    height: 1.333333rem;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    vertical-align: top;
    img {
      height: 0.64rem;
      width: 0.64rem;
    }

    p {
      margin-top: 0.133333rem;
      font-size: 10px;
    }

    &.selected {
      color: #c92d27;
    }

    &.twofor {
      width: 50%;
    }

    &.threefor {
      width: 33.333333%;
    }

    &.fourfor {
      width: 25%;
    }
    &.fivefor {
      width: 20%;
    }
  }

  .personal {
    padding: 0.266667rem;
    position: absolute;
    left: 50%;
    background: #fff;
    border-radius: 50%;
    top: -0.453333rem;
    transform: translateX(-50%);
    height: 1.6rem;
    img {
      height: 1.173333rem;
      width: 1.173333rem;
    }
  }
  &-phone {
    display: flex;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
    justify-content: center;
    align-items: center;

    &-title {
      margin: 0.4rem 0;
      font-size: 18px;
      font-weight: bold;
    }

    &-tel {
      font-size: 16px;
      margin: 0 0 0.4rem;
    }
  }

  &-modal-main {
    width: 75vw;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.85);
    opacity: 1;
    border-radius: 10px;
    -webkit-box-shadow: 0 0px 6px rgba(0, 0, 0, 0.35);
    box-shadow: 0 0px 6px rgba(0, 0, 0, 0.35);
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-animation: bounce-show 0.2s cubic-bezier(0.18, 0.89, 0.32, 1.28);
    animation: bounce-show 0.2s cubic-bezier(0.18, 0.89, 0.32, 1.28);
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }

  &-footer {
    display: flex;
    border-top: 1px solid #cecece;
    font-size: 15px;

    .footer-item {
      padding: 0.266667rem 0;
      flex: 1 1;
      text-align: center;
      color: #0980ff;
      -webkit-transition: background-color 0.1s ease-out;
      transition: background-color 0.1s ease-out;

      &:hover {
        background-color: #ccc;
      }

      &:first-child {
        border-right: 1px solid #cecece;
      }
    }
  }

  @-webkit-keyframes bounce-show {
    from {
      opacity: 0;
      transform: scale(0.4);
    }
  }

  @keyframes bounce-show {
    from {
      opacity: 0;
      transform: scale(0.4);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/Navbar.vue